'use client'
import useMulticityJourneyLabels from '@/src/hooks/srp/multicity/useMulticityJourneyLabels'
import useStopFilterManager from '@/src/hooks/srp/stopFilterManager'
import useSearchResults from '@/src/hooks/srp/useSearchResults'
import React, { useState } from 'react'
import MulticityJourneySegmentTabs from '../multicityJourneySegmentTabs'
import StopsFilter from './StopsFilter'

const StopsFilterWrapper = React.memo(() => {
    const [journeyIndex, setJourneyIndex] = useState(0)
    const { isMulticity, journeyCount } = useSearchResults()
    const journeys = useMulticityJourneyLabels()
    const filterJourneyIndex = isMulticity ? journeyIndex : 0
    const { stopOptions, stopReset, stopResetAllJourneys, stopToggle, shouldShowReset, shouldShowResetForAllJourneys, title } = useStopFilterManager(filterJourneyIndex)

    const journeyTabs =
        isMulticity && journeyCount > 1 ? (
            <MulticityJourneySegmentTabs
                journeys={journeys}
                selectedIndex={journeyIndex}
                onSelect={setJourneyIndex}
            />
        ) : null

    return (
        <StopsFilter
            stopOptions={stopOptions}
            onOptionClick={stopToggle}
            onStopsReset={isMulticity ? stopResetAllJourneys : stopReset}
            shouldShowReset={isMulticity ? shouldShowResetForAllJourneys : shouldShowReset}
            title={title}
            journeyTabs={journeyTabs}
        />
    )
})

StopsFilterWrapper.displayName = 'StopsFilterWrapper'

export { StopsFilterWrapper }
export default StopsFilterWrapper
